module.exports = __webpack_public_path__ + "img/aiminne.28a1b922.png";